module.exports = __webpack_public_path__ + "img/totalizador-conforme.2ae638f7.svg";